module.exports = __WEBPACK_EXTERNAL_MODULE__87781__;